var _g, _ellipse, _path, _path2, _ellipse2, _path3, _ellipse3, _path4, _path5, _ellipse4, _path6, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _path7, _g11, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlueCar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 58,
    viewBox: "0 0 92 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_19957_74209)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.6824 53.0439C73.4674 52.0108 80.3844 49.1016 82.9003 46.8827C85.7952 44.5668 79.9852 41.7475 79.2981 41.3274C78.6109 40.9073 44.7677 23.1376 38.8563 20.3705C32.9449 17.6034 13.8738 22.6452 9.22544 25.0603C5.43644 27.0289 8.03955 28.5546 8.52746 28.9696C9.01536 29.3847 37.1624 45.9303 47.3016 51.0193C54.98 54.8731 62.2528 55.0716 69.6824 53.0439Z",
    fill: "#D1D5DB"
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.48031,
    cy: 7.59289,
    rx: 4.48031,
    ry: 7.59289,
    transform: "matrix(-0.92318 0.384368 0.385938 0.922525 51.4878 31.2051)",
    fill: "#1A1E25"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.3062 32.9648L43.4698 34.618L49.448 48.5779L53.2132 46.953L47.3062 32.9648Z",
    fill: "#1A1E25"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.0322 43.6453C43.6494 47.5108 46.8122 49.8734 49.0965 48.9223C51.3809 47.9713 51.9217 44.0667 50.3045 40.2012C48.6873 36.3356 45.4329 33.7648 43.1485 34.7158C40.8642 35.6669 40.4151 39.7797 42.0322 43.6453Z",
    fill: "#2A313C"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.15092,
    cy: 5.48482,
    rx: 3.15092,
    ry: 5.48482,
    transform: "matrix(-0.918945 0.394387 0.372877 0.927881 47.0122 35.4219)",
    fill: "#D1D5DB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.2126 43.1071C44.9212 44.5763 46.0282 45.5518 47.0072 45.624L46.3717 43.6139C45.9838 43.4915 45.5787 43.1147 45.2831 42.5771L44.2126 43.1071ZM47.3104 41.5744C47.5882 42.4771 47.4417 43.3275 46.9445 43.5817L47.5601 45.5287L47.4453 45.5928C47.5236 45.5747 47.6005 45.5505 47.6755 45.5184C48.8193 45.0275 49.118 43.0532 48.3829 41.0435L47.3104 41.5744ZM44.599 38.007C43.4714 38.5448 43.2027 40.5667 43.9894 42.5922L45.0549 42.065C44.7508 41.2058 44.831 40.366 45.2336 40.0141L44.599 38.007ZM45.1402 37.8741L45.763 39.8467C46.2327 39.892 46.7584 40.3565 47.103 41.0521L48.1705 40.524C47.4241 38.8925 46.1876 37.8314 45.1402 37.8741Z",
    fill: "#83888E"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.62497,
    cy: 6.48489,
    rx: 3.62497,
    ry: 6.48489,
    transform: "matrix(-0.912031 0.410121 0.361196 0.93249 20.71 16.7207)",
    fill: "#1A1E25"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3677 18.2402L14.3012 19.6674L19.0797 31.719L22.0893 30.3162L17.3677 18.2402Z",
    fill: "#1A1E25"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.152 27.4624C14.4447 30.7995 16.9727 32.8392 18.7987 32.0181C20.6246 31.1971 21.0569 27.8262 19.7642 24.4891C18.4716 21.152 15.8702 18.9326 14.0443 19.7537C12.2184 20.5747 11.8594 24.1253 13.152 27.4624Z",
    fill: "#2A313C"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.551,
    cy: 4.68783,
    rx: 2.551,
    ry: 4.68783,
    transform: "matrix(-0.907272 0.420544 0.34872 0.937227 17.1338 20.3633)",
    fill: "#D1D5DB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9282 27.0691C15.4694 28.241 16.2816 29.0341 17.0218 29.1579L16.503 27.3846C16.2465 27.2527 15.9896 26.9794 15.7881 26.6092L14.9282 27.0691ZM17.3923 25.7524C17.5847 26.5016 17.4626 27.1939 17.0793 27.4067L17.572 29.0882L17.4799 29.144C17.5421 29.1284 17.6034 29.1079 17.663 29.0803C18.5638 28.6628 18.81 27.001 18.2551 25.2926L17.3923 25.7524ZM15.1155 22.6458C14.2889 23.1761 14.108 24.8638 14.7157 26.554L15.5677 26.0988C15.3451 25.42 15.3795 24.7544 15.6335 24.4132L15.1155 22.6458ZM15.6376 22.4804L16.1357 24.1826C16.5109 24.2228 16.9295 24.6243 17.2045 25.2243L18.0595 24.7682C17.4631 23.3604 16.4746 22.4446 15.6376 22.4804Z",
    fill: "#83888E"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_ii_19957_74209)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.9935 8.74628C43.935 4.98005 38.5325 4.20106 33.8459 4.5668C32.9684 4.63521 30.7594 4.15286 29.2156 4.45126C28.7934 4.53442 18.1198 8.11145 14.1908 9.74078C11.1852 10.9872 10.9975 11.8931 10.7425 12.4325C10.5175 12.909 10.3528 14.0418 10.3802 14.8157C10.3822 14.872 10.3733 14.9283 10.3564 14.9821C10.2427 15.3441 10.081 16.274 10.0339 16.6424C9.74683 18.889 9.78546 20.9706 10.1664 23.2006C10.2932 23.934 12.4793 25.9019 12.5036 25.6826C12.5274 25.4626 12.4123 24.3302 12.5615 23.0572C12.6698 22.1329 13.1346 20.48 14.7004 20.0344C16.2662 19.589 17.9431 20.985 19.0655 23.0582C20.7399 26.1512 20.0234 28.853 20.2091 30.5388C20.2221 30.6558 20.2951 30.7562 20.3985 30.8123L40.6313 41.7558C40.7098 41.7982 40.7936 41.8088 40.8716 41.7953C40.9067 41.7892 40.9434 41.7916 40.9745 41.8088C41.0565 41.854 41.1576 41.799 41.1613 41.7054C41.1643 41.6266 41.1654 41.5569 41.1655 41.4948C41.1674 41.4795 41.1716 41.4642 41.1715 41.4481C41.1708 40.83 41.0684 40.6659 41.0506 40.092C41.0228 39.1878 40.9164 35.4009 43.5844 34.5598C45.9352 33.8189 48.824 36.8129 50.1559 39.2153C50.7306 40.252 51.236 41.8399 51.607 43.4312C51.9212 44.8649 52.1258 46.2894 52.1799 47.3042C52.1816 47.3355 52.1975 47.3623 52.2252 47.3769C52.2438 47.3867 52.2596 47.4042 52.2688 47.4231C52.3019 47.4914 52.3535 47.549 52.4238 47.5861C52.8966 47.8352 53.8699 48.3232 55.1586 48.8355C58.1736 50.1624 62.8847 51.6909 67.0074 50.5165C79.2275 47.0354 81.8196 43.4331 82.3626 42.4464C82.9067 41.4576 82.802 40.5604 82.8481 39.7537L82.9013 37.6929C82.9431 36.0576 82.9939 34.6569 82.992 34.1189C82.9901 33.5812 83.6256 32.0422 80.8356 29.0918C78.3304 26.4426 66.7008 19.7143 65.3026 19.3041C65.1908 19.2712 65.0662 19.2103 64.9273 19.1255C64.8891 19.1022 64.854 19.0759 64.8203 19.0466C63.8523 18.2047 62.1059 16.4404 59.511 14.3616C57.937 13.0339 56.0407 11.5832 53.7777 10.207C52.875 9.6581 51.94 9.17411 50.9935 8.74628Z",
    fill: "url(#paint0_linear_19957_74209)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_ddi_19957_74209)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.8941 26.6372C43.3206 25.5012 41.9492 21.9491 38.1058 17.7331C38.0148 17.6332 38.0521 17.4713 38.1789 17.4244L54.4607 11.3953C54.4892 11.3847 54.5192 11.3812 54.5487 11.3885C54.8289 11.4577 56.481 12.0137 60.9858 16.1582C63.2457 18.2373 63.695 18.7753 64.8688 19.6056C65.0544 19.737 65.0145 20.0148 64.3061 20.5659C62.0479 22.3227 49.6977 28.3161 45.8941 26.6372Z",
    fill: "url(#paint1_radial_19957_74209)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_di_19957_74209)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.9088 12.562C24.5191 11.4066 23.6399 11.3784 21.2844 11.1866C19.6636 11.0547 17.0804 11.2283 16.7807 11.9478C16.481 12.6673 19.5428 15.0279 20.8161 15.771C21.4385 16.1342 42.9366 27.5327 42.277 26.233C41.4642 24.6317 37.653 20.02 36.3591 18.1435C34.2018 15.0149 31.2984 13.7174 27.9088 12.562Z",
    fill: "url(#paint2_radial_19957_74209)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_di_19957_74209)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.2186 10.2284L34.7021 4.78516C34.7021 4.78516 34.378 4.88967 32.6196 4.81954C32.006 4.79507 16.9728 10.5003 16.8617 10.5925L20.2186 10.2284Z",
    fill: "url(#paint3_linear_19957_74209)"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_f_19957_74209)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.2815 34.6293C46.8411 31.9461 43.8291 28.6741 40.5869 25.6709C50.3895 28.8317 70.8997 35.7247 70.5652 36.1312C70.1471 36.6393 68.6466 37.2167 63.7046 37.4229C58.8391 37.626 52.9045 34.9365 52.2815 34.6293Z",
    fill: "url(#paint4_linear_19957_74209)",
    fillOpacity: 0.21
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_di_19957_74209)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.8877 26.5052C32.8896 26.4327 32.8498 26.3655 32.7852 26.3322L30.9176 25.3702C30.7931 25.3061 30.6442 25.3942 30.6406 25.534L30.6326 25.8492C30.6307 25.9219 30.6707 25.9891 30.7354 26.0224L32.6031 26.9807C32.7275 27.0446 32.8762 26.9565 32.8798 26.8168L32.8877 26.5052Z",
    fill: "#4E545D"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_di_19957_74209)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.4732 21.6185C22.475 21.546 22.4352 21.4788 22.3706 21.4455L20.503 20.4835C20.3786 20.4194 20.2297 20.5074 20.2261 20.6473L20.218 20.9625C20.2162 21.0352 20.2561 21.1024 20.3208 21.1356L22.1885 22.094C22.313 22.1578 22.4616 22.0698 22.4652 21.93L22.4732 21.6185Z",
    fill: "#4E545D"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.17,
    filter: "url(#filter8_f_19957_74209)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78.7471 32.2754C75.2595 34.8788 67.5556 38.5318 64.1447 39.0325",
    stroke: "url(#paint5_linear_19957_74209)",
    strokeWidth: 6.25786,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_ddii_19957_74209)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M81.3307 33.3239C82.013 32.4549 81.8479 31.7418 81.7791 30.6267C81.7773 30.5972 81.771 30.5655 81.7626 30.5371C81.4986 29.6495 82.7001 31.5049 82.7984 32.7703C82.8308 33.189 82.7984 33.3998 82.7492 33.7843C82.7266 33.9602 82.3343 35.0276 82.3825 35.2614C82.4307 35.4952 82.2709 37.0942 82.2729 37.3366C82.2749 37.5789 81.2121 39.3547 78.4965 41.0249C76.2407 42.4123 73.0304 43.2793 72.7026 43.3178C72.3748 43.3562 72.0825 42.2587 71.8469 42.1925C71.2304 42.0193 69.3803 42.6426 68.6917 42.7964C67.8882 42.9758 66.0134 43.3891 63.9839 43.0776C61.4737 42.6924 61.0955 42.3981 58.8123 41.0861C57.3563 40.2494 56.3307 38.6986 55.9182 37.7717C55.8097 37.5279 56.0311 37.3184 56.2824 37.4081C57.8673 37.9736 61.1626 39.2462 64.91 39.724C70.4535 40.4308 74.9105 37.9153 75.549 37.5536C78.2333 36.0333 79.6369 35.4816 81.3307 33.3239Z",
    fill: "#1A1E25"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_19957_74209",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 55,
    y: 30,
    width: 29,
    height: 14
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M81.3328 33.3112C81.8876 32.6035 81.926 31.761 81.8033 31.0255C81.74 30.6457 82.1159 30.444 82.3075 30.778C82.8135 31.6604 83.0173 32.407 83.0694 32.8136C83.1021 33.2323 83.0851 33.4972 83.0361 33.8817C83.0137 34.0576 82.3374 35.0143 82.3858 35.2481C82.4342 35.4819 82.2753 37.081 82.2775 37.3233C82.2797 37.5656 81.218 39.3421 78.5035 41.014C76.2485 42.4028 73.0388 43.2719 72.711 43.3106C72.3832 43.3493 72.0902 42.2519 71.8546 42.1859C71.238 42.0131 69.3884 42.6375 68.6998 42.7918C67.8964 42.9717 66.0219 43.3862 63.9922 43.076C61.4817 42.6924 61.1034 42.3983 58.8194 41.0878C57.3628 40.252 56.3362 38.7019 55.9231 37.7753C55.8145 37.5315 56.0357 37.3219 56.2871 37.4114C57.8724 37.9759 61.1685 39.2464 64.9162 39.7218C70.4601 40.4251 74.9155 37.9067 75.5538 37.5446C78.2371 36.0226 79.6403 35.47 81.3328 33.3112Z",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_19957_74209)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter10_d_19957_74209)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.4119 38.7985C67.4502 39.012 67.466 39.2956 67.3854 39.5862C67.3056 39.8737 67.1293 40.1748 66.7711 40.4276C66.4553 40.6505 65.9929 40.8401 65.3206 40.9445L65.0193 40.9831C64.5212 41.0368 63.835 41.0172 63.1334 40.8664C62.5188 40.7343 61.8994 40.504 61.3861 40.1409L61.1734 39.9766C60.8761 39.7283 60.5156 39.2442 60.2237 38.8089C60.0796 38.5939 59.9554 38.3945 59.8666 38.2493C59.8638 38.2448 59.8617 38.2399 59.859 38.2355L67.3474 38.5369C67.3481 38.5393 67.3485 38.5421 67.3493 38.5446C67.3685 38.6049 67.3928 38.6924 67.4119 38.7985Z",
    stroke: "white",
    strokeWidth: 0.28216
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter11_d_19957_74209)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M81.79 31.0084C81.8559 31.1311 81.9375 31.3078 82.0002 31.5223C82.1098 31.8978 82.1597 32.3844 81.9696 32.9032L81.8732 33.1277C81.7878 33.299 81.6691 33.4118 81.5496 33.4565C81.4658 33.4878 81.3698 33.49 81.2653 33.44L81.1581 33.3721C81.0594 33.2939 80.9208 33.2599 80.7929 33.2439C80.6599 33.2273 80.5136 33.2274 80.381 33.2341C80.3188 33.2372 80.2589 33.2453 80.2032 33.2506L81.7827 30.9963C81.7849 31.0003 81.7878 31.0043 81.79 31.0084Z",
    stroke: "white",
    strokeWidth: 0.28216
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_19957_74209",
    x: 6.37597,
    y: 18.7363,
    width: 78.1538,
    height: 36.4063,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.413089,
    result: "effect1_foregroundBlur_19957_74209"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_ii_19957_74209",
    x: 9.8457,
    y: 2.47245,
    width: 74.6178,
    height: 48.4631,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.4108,
    dy: -1.88107
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.6432
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.07 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_19957_74209"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.235133
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.470266
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.09 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_19957_74209",
    result: "effect2_innerShadow_19957_74209"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_ddi_19957_74209",
    x: 37.6764,
    y: 11.1003,
    width: 27.4766,
    height: 16.1158,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.189632,
    dy: 0.094816
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.094816
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.28 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_19957_74209"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.094816
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.094816
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.56 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_19957_74209",
    result: "effect2_dropShadow_19957_74209"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_19957_74209",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.094816,
    dy: 0.284448
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.142224
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.75 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect3_innerShadow_19957_74209"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_di_19957_74209",
    x: 16.381,
    y: 11.1465,
    width: 26.0091,
    height: 15.5687,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.098052
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.049026
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.925374 0 0 0 0 0.925374 0 0 0 0 0.925374 0 0 0 0.37 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_19957_74209"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_19957_74209",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.379264,
    dy: 0.47408
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.189632
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_19957_74209"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_di_19957_74209",
    x: 16.4826,
    y: 4.78516,
    width: 18.3176,
    height: 6.1859,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.098052
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.049026
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.925374 0 0 0 0 0.925374 0 0 0 0 0.925374 0 0 0 0.37 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_19957_74209"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_19957_74209",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.379264,
    dy: 0.47408
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.189632
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_19957_74209"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f_19957_74209",
    x: 37.9321,
    y: 23.017,
    width: 35.2921,
    height: 17.0714,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.32742,
    result: "effect1_foregroundBlur_19957_74209"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_di_19957_74209",
    x: 30.5853,
    y: 25.2556,
    width: 2.34942,
    height: 1.98153,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.0470266
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.0235133
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.78755 0 0 0 0 0.78755 0 0 0 0 0.78755 0 0 0 0.19 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_19957_74209"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_19957_74209",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.235133
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.117567
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.74 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_19957_74209"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_di_19957_74209",
    x: 20.1707,
    y: 20.3688,
    width: 2.34942,
    height: 1.98153,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.0470266
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.0235133
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.78755 0 0 0 0 0.78755 0 0 0 0 0.78755 0 0 0 0.19 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_19957_74209"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_19957_74209",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.235133
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.117567
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.74 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_19957_74209"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_f_19957_74209",
    x: 60.067,
    y: 28.1983,
    width: 22.7572,
    height: 14.9119,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.47408,
    result: "effect1_foregroundBlur_19957_74209"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_ddii_19957_74209",
    x: 55.7721,
    y: 30.1277,
    width: 27.1574,
    height: 14.0042,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.088509
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.059006
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.57 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_19957_74209"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.059006
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.059006
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_19957_74209",
    result: "effect2_dropShadow_19957_74209"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_19957_74209",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.813466
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.82901
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect3_innerShadow_19957_74209"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.0886441
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.0886441
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_innerShadow_19957_74209",
    result: "effect4_innerShadow_19957_74209"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_d_19957_74209",
    x: 59.5802,
    y: 38.084,
    width: 8.21511,
    height: 3.30202,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.0940533,
    dy: 0.116832
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.0584159
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.24 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_19957_74209"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_19957_74209",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11_d_19957_74209",
    x: 79.8849,
    y: 30.7383,
    width: 2.56472,
    height: 3.11452,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.0940533,
    dy: 0.116832
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.0584159
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.24 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_19957_74209"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_19957_74209",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_19957_74209",
    x1: 50.5619,
    y1: 48.4583,
    x2: 85.0581,
    y2: 8.29714,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0564FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6FA6FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_19957_74209",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(64.9334 11.563) rotate(149.971) scale(31.1695 16.1467)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#343A46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.592618,
    stopColor: "#1A1E25"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_19957_74209",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(40.3588 9.06042) rotate(137.121) scale(29.5825 16.9928)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#343A46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.592618,
    stopColor: "#1A1E25"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_19957_74209",
    x1: 15.0123,
    y1: 22.6,
    x2: 25.5374,
    y2: 7.92125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8EAE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.498386,
    stopColor: "#707072"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F3032"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_19957_74209",
    x1: 54.4006,
    y1: 37.8659,
    x2: 56.9339,
    y2: 30.9923,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECEAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_19957_74209",
    x1: 71.5782,
    y1: 39.1443,
    x2: 70.0654,
    y2: 35.9913,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B4B4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.899322,
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueCar);
export default __webpack_public_path__ + "static/media/blueCar.ec9c3e453a3f63ab52ac1d31fadc8fc7.svg";
export { ForwardRef as ReactComponent };